// project imports
import { alpha } from '@mui/material/styles';
import { ThemeMode } from 'config';

export default function Typography(theme, borderRadius, fontFamily, fontSize) {
  return {
    fontFamily,
    h6: {
      fontWeight: 500,
      color: theme.palette.grey[900],
      fontSize: `calc(${fontSize}px - 4px)`
    },
    h5: {
      fontSize: `calc(${fontSize}px - 2px)`,
      color: theme.palette.grey[900],
      fontWeight: 500
    },
    h4: {
      fontSize: `${fontSize}px`,
      color: theme.palette.grey[900],
      fontWeight: 500
    },
    h3: {
      fontSize: `calc(${fontSize}px + 2px)`,
      color: theme.palette.grey[900],
      fontWeight: 500
    },
    h2: {
      fontSize: `calc(${fontSize}px + 4px)`,
      color: theme.palette.grey[900],
      fontWeight: 500
    },
    h1: {
      fontSize: `calc(${fontSize}px + 8px)`,
      color: theme.palette.grey[900],
      fontWeight: 600
    },
    subtitle1: {
      fontSize: `calc(${fontSize}px - 2px)`,
      fontWeight: 500,
      color: theme.palette.text.dark
    },
    subtitle2: {
      fontSize: `calc(${fontSize}px - 4px)`,
      fontWeight: 400,
      color: theme.palette.text.secondary
    },
    caption: {
      fontSize: `calc(${fontSize}px - 4px)`,
      color: theme.palette.text.secondary,
      fontWeight: 400,
      lineHeight: '1'
    },
    body1: {
      fontSize: `calc(${fontSize}px - 2px)`,
      fontWeight: 400,
      lineHeight: '1.334em'
    },
    body2: {
      letterSpacing: '0em',
      fontWeight: 400,
      lineHeight: '1.5em',
      color: theme.palette.text.primary,
      fontSize: `${fontSize}px`
    },
    body3: {
      fontWeight: 400,
      fontSize: `calc(${fontSize}px + 2px)`
    },
    button: {
      fontSize: `calc(${fontSize}px - 2px)`,
      textTransform: 'capitalize',
      '&.MuiButton-outlinedPrimary': {
        color: theme.palette.mode === ThemeMode.DARK ? theme.palette.dark.light : theme.palette.primary.main,
        borderColor: theme.palette.mode === ThemeMode.DARK ? alpha(theme.palette.dark.light, 1) : theme.palette.grey[400]
      },
      '&.MuiButton-containedPrimary': {
        boxShadow: 'none'
      }
    },
    customInput: {
      marginTop: 1,
      fontSize: `${fontSize}px`,
      marginBottom: 1,
      '& > label': {
        top: 23,
        left: 0,
        color: theme.palette.grey[500],
        '&[data-shrink="false"]': {
          top: 5
        }
      },
      '& > div > input': {
        padding: '30.5px 14px 11.5px !important'
      },
      '& legend': {
        display: 'none'
      },
      '& fieldset': {
        top: 0
      }
    },
    mainContent: {
      backgroundColor: theme.palette.mode === ThemeMode.DARK ? theme.palette.dark[800] : theme.palette.grey[100],
      width: '100%',
      minHeight: 'calc(100vh - 88px)',
      flexGrow: 1,
      padding: '20px',
      marginTop: '88px',
      marginRight: '20px',
      borderRadius: `${borderRadius}px`,
      fontSize: `${fontSize}px`
    },
    menuCaption: {
      fontSize: `calc(${fontSize}px - 2px)`,
      fontWeight: 500,
      color: theme.palette.mode === ThemeMode.DARK ? theme.palette.grey[600] : theme.palette.grey[900],
      padding: '6px',
      textTransform: 'capitalize',
      marginTop: '10px'
    },
    subMenuCaption: {
      fontSize: `calc(${fontSize}px - 5px)`,
      fontWeight: 500,
      color: theme.palette.text.secondary,
      textTransform: 'capitalize'
    },
    commonAvatar: {
      cursor: 'pointer',
      borderRadius: '8px',
      fontSize: `${fontSize}px`
    },
    smallAvatar: {
      width: '22px',
      height: '22px',
      fontSize: `${fontSize}px`
    },
    mediumAvatar: {
      width: '34px',
      height: '34px',
      fontSize: `calc(${fontSize}px + 3.2px)`
    },
    largeAvatar: {
      width: '44px',
      height: '44px',
      fontSize: `calc(${fontSize}px + 8px)`
    },
    // include the name to make the font-size global
    includeFontSize: {
      fontSize: `${fontSize}px`
    }
  };
}
